import { mainStartUp } from "./js/main.js";
import { analyticsInit } from "./js/analytics.js";
import { controlStartUp } from "./js/control.js";
import { browserMenuToggleInit, onBrowserTooltip } from "./js/browser.js";
import { tagsDynamicFetch } from "./js/tags.js";
import { mapInit, mapFetchPosters, mapRadioLabelFilterChange } from "./js/map.js";
import { Log } from "./js/log.js";
import { empOnClickLink, empEditorWakeUp } from "./js/emp.js";
import { posterRender, posterParseDocument } from "./js/poster.js";
import { linksCreate } from "./js/links.js";
import { adsensePushFullAds} from "./js/adsense.js";
import { subscriptionSendNewConnection, subscriptionLoadForm } from "./js/subscription.js";



function startMain(label = null, town = null, region = null) {
    mainStartUp(label, town, region);
    analyticsInit(false);
    controlStartUp("mainSentinel");
    browserMenuToggleInit(
            "mainMenuButton",
            "mainMenuNav",
            "mainMenuNavInvisible",
            "mainMenuClose"
            );
    tagsDynamicFetch();
    subscriptionLoadForm();
    subscriptionSendNewConnection();
    empEditorWakeUp();
}

function startPage()
{
    analyticsInit(false);
    browserMenuToggleInit(
            'mainMenuButton',
            'mainMenuNav',
            'mainMenuNavInvisible',
            'mainMenuClose');
    posterRender();
    posterParseDocument();
    tagsDynamicFetch();
    subscriptionLoadForm();
    subscriptionSendNewConnection();
    empEditorWakeUp();
}

function startLinks()
{
    linksCreate('posterLinksWrapper');
    controlStartUp('posterSentinel');
}

function startList()
{
    analyticsInit(false);
    browserMenuToggleInit(
            'mainMenuButton',
            'mainMenuNav',
            'mainMenuNavInvisible',
            'mainMenuClose');
}

function startMap() {
    Log.init();
    mapInit();
    tagsDynamicFetch();
    mapFetchPosters(
            document.getElementById("mapWindowInfo"),
            document.getElementById("mapPosters")
            );
    analyticsInit(false);
    subscriptionLoadForm();
    browserMenuToggleInit(
            "mainMenuButton",
            "mainMenuNav",
            "mainMenuNavInvisible",
            "mainMenuClose"
            );
}

window.startMain = startMain;
window.startPage = startPage;
window.startLinks = startLinks;
window.startList = startList;
window.startMap = startMap;
window.empOnClickLink = empOnClickLink;
window.adsensePushFullAds = adsensePushFullAds;
window.mapRadioLabelFilterChange = mapRadioLabelFilterChange;
window.onBrowserTooltip = onBrowserTooltip;
window.analyticsInit = analyticsInit;
window.subscriptionLoadForm = subscriptionLoadForm;
